import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import PushNotificationBanner from '../social/PushNotificationBanner';
import Sidebar from './Sidebar';
import { ChatProvider, useChatContext } from '../../context/ChatContext';
import { LayoutProvider } from '../../context/LayoutContext';
import { Linkedin, Mail } from 'lucide-react';

function Footer() {
  return (
    <footer className="w-full bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-4">
      {/* lg:pl-64 clears the sidebar; inner div adds breathing room matching the page content padding */}
      <div className="lg:pl-64">
      <div className="px-4 sm:px-6 md:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
          <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
            Created by <span className="font-semibold text-gray-900 dark:text-white">Baktash Ansari</span>
          </p>
          <div className="flex items-center justify-center gap-4 sm:gap-6">
            <a
              href="https://www.linkedin.com/in/baktashans/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-xs sm:text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors py-2"
            >
              <Linkedin className="h-4 w-4" />
              <span>LinkedIn</span>
            </a>
            <a
              href="mailto:baktash.ansari1381@gmail.com"
              className="flex items-center gap-1.5 text-xs sm:text-sm text-gray-600 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 transition-colors py-2"
            >
              <Mail className="h-4 w-4" />
              <span>Email</span>
            </a>
          </div>
        </div>
      </div>
      </div>
    </footer>
  );
}

function LayoutContent() {
  const { currentConversationId, loadConversation, startNewConversation } = useChatContext();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
      <Navbar />
      <PushNotificationBanner />
      {/* pt-14/pt-16 clears the fixed navbar height */}
      <div className="flex flex-1 pt-14 sm:pt-16">
        <Sidebar
          onSelectConversation={loadConversation}
          onNewChat={startNewConversation}
          currentConversationId={currentConversationId}
        />
        <main className="flex-1 min-w-0 lg:ml-64">
          <Outlet />
        </main>
      </div>
      {/* Footer is full-width sibling of the content row, not inside <main> */}
      <Footer />
    </div>
  );
}

export default function Layout() {
  return (
    <LayoutProvider>
      <ChatProvider>
        <LayoutContent />
      </ChatProvider>
    </LayoutProvider>
  );
}
